import styled, { css } from 'styled-components';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { IS_MOBILE as isMobile } from 'utils/constants';
import { Colors } from 'components/utils/styles/ui';
import { Emoji } from 'components/elements/styles/emoji';

export const BrowserBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 3rem;
  background-color: ${Colors.grey};
  color: ${Colors.text};
  white-space: pre-wrap;

  & > a {
    color: ${Colors.text};
    text-decoration: underline;
  }
`;

export const mobileFlashMessage = css`
  left: 0;
  margin: 0 1.2rem 2.4rem 1.2rem;
  padding: 0;
  width: calc(100vw - 2.4rem);

  .Toastify__toast {
    font-size: 1.6rem;
    border-radius: 0.8rem;
    line-height: 2.4rem;
    box-shadow: 0 0 1.6rem rgba(19, 41, 61, 0.08),
      0 0.6rem 1.6rem rgba(19, 41, 61, 0.12);
    padding: 0 1.6rem;
    margin: 0.8rem 0 0 0;
  }

  .Toastify__toast--success {
    background-color: ${Colors.greenLighter};
    color: ${Colors.greenDark};

    .Toastify__progress-bar {
      background-color: ${Colors.greenLighter};
    }
  }

  .Toastify__toast--info {
    background-color: ${Colors.white};
    color: ${Colors.textLight};
  }

  .Toastify__close-button {
    display: none;
  }

  .Toastify__toast-body {
    padding: 0;

    & > span {
      display: flex;
    }

    ${Emoji} {
      margin-right: 0.8rem;
    }

    a {
      margin-left: auto;
      text-decoration: underline;
      line-height: 2.5rem;
    }
  }
`;

export const FlashMessage = styled(ToastContainer)`
  ${({ theme }) => theme.typography.text.large};
  margin: 0 0 2rem 4.5rem;
  white-space: pre-wrap;

  .Toastify__toast {
    font-family: ${({ theme }) => theme.fonts.text};
  }

  .Toastify__toast--success {
    background-color: ${Colors.green};

    .Toastify__progress-bar {
      background-color: ${Colors.greenLight};
    }
  }

  .Toastify__toast--error {
    background-color: ${Colors.red};

    .Toastify__progress-bar {
      background-color: ${Colors.redLight};
    }
  }

  .Toastify__toast--info {
    background-color: ${Colors.textLighter};
  }

  ${isMobile && mobileFlashMessage}
`;
